<h2 mat-dialog-title>Save Search</h2>

<mat-dialog-content>
  <div class="row">
    <mat-form-field appearance="fill" style="flex:1">
      <mat-label>Name</mat-label>
      <input matInput [formControl]="nameCtrl" placeholder="Search name" />
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="fill" style="flex:1">
      <mat-label>Description</mat-label>
      <input matInput [formControl]="descriptionCtrl" placeholder="Optional" />
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button color="lightGreen" mat-flat-button (click)="save()">Save</button>
</mat-dialog-actions>


